import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../models/states/StoreState";
import { changeLanguage } from "../redux/actions";

export function useLanguage(): [string, (code: string) => void] {
    const language = useSelector((state: StoreState) => state.interview.language);
    const dispatch = useDispatch();

    function setLanguage(code: string) {
        dispatch(changeLanguage(code));
    }

    return [language, setLanguage];
}
